"use client"

import posthog from "posthog-js"
import { useEffect } from "react"
import { Ccm19EmbeddingName } from "src/integrations/ccm19/embeddings"
import { useCcm19EmbeddingAccepted } from "src/integrations/ccm19/useConsented"
import { integrationDebug } from "src/integrations/lib/api"
import { posthogOptions, posthogPublicWriteKey } from "src/integrations/posthog/constants"
import { isBrowser } from "src/utilities/env"
import { runOnceInBrowser } from "src/utilities/runOnceInBrowser"

function initPosthog() {
  runOnceInBrowser("posthog.init", () => {
    console.debug("🦔", posthogOptions)
    posthog.init(posthogPublicWriteKey, posthogOptions)
    integrationDebug("posthog", "initialized")
  })
}

if (isBrowser && window.location.href.includes("#__posthog=")) {
  initPosthog()
}

export const PosthogTag = () => {
  const consented = useCcm19EmbeddingAccepted(Ccm19EmbeddingName.Posthog)

  useEffect(() => {
    if (consented) {
      initPosthog()
      posthog.opt_in_capturing()
    } else {
      posthog.opt_out_capturing()
    }
  }, [consented])

  return null
}
